const forbiddenPasswords = ['Password', 'password', 'Contraseña', 'contraseña'];

export const validatePassword = (
  password: string,
  changePassword?: { oldPassword?: string; repeatPassword?: string }
) => {
  const passwordValidation: { [key: string]: string[] } = {};
  const errors: string[] = [];
  const repeatPasswordErrors: string[] = [];

  if (!password) return;

  // Minimum 12 characters
  if (password.length < 12) {
    errors.push('La contraseña debe tener al menos 12 caracteres.');
  }

  // List of forbidden passwords
  if (forbiddenPasswords.includes(password)) {
    errors.push('Contraseña poco segura.');
  }

  // At least one uppercase
  if (!/[A-Z]/.test(password)) {
    errors.push('La contraseña debe contener al menos una letra mayúscula.');
  }

  // At least one lowercase
  if (!/[a-z]/.test(password)) {
    errors.push('La contraseña debe contener al menos una letra minúscula.');
  }

  // At least one number
  if (!/\d/.test(password)) {
    errors.push('La contraseña debe incluir al menos un número.');
  }

  // Special characters allowed by policy
  const allowedSpecialChars = /^[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=\sA-Za-z0-9]*$/;

  // Check at least one allowed special char
  if (!/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]/.test(password)) {
    errors.push('La contraseña debe incluir al menos un carácter especial.');
  }

  // Check that all special characters are allowed (no emojis or invalid symbols)
  if (!allowedSpecialChars.test(password)) {
    errors.push('La contraseña contiene caracteres no permitidos.');
  }

  // Spaces: allowed only if not leading or trailing
  if (/^\s|\s$/.test(password)) {
    errors.push('La contraseña no debe iniciar ni terminar con un espacio.');
  }

  if (changePassword) {
    if (changePassword.repeatPassword && changePassword.repeatPassword !== password) {
      repeatPasswordErrors.push('Las contraseñas deben coincidir.');
    }
    if (changePassword.oldPassword && password === changePassword.oldPassword) {
      errors.push('La nueva contraseña no debe ser igual a la actual.');
    }
  }

  if (errors.length > 0) passwordValidation['errors'] = errors;
  if (repeatPasswordErrors.length > 0) passwordValidation['repeatPasswordErrors'] = repeatPasswordErrors;

  return Object.keys(passwordValidation).length > 0 ? passwordValidation : undefined;
};
